import React from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { MediaListImageItem } from '~admin/view/components/ui/form/fields/media/media-list/media-list-image-item.component';
import { Box } from '~common/components/box.component';

interface Props {
  mediaList: MediaData[];
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaListImage: React.FunctionComponent<Props> = ({ mediaList, onMediaSelected }) => {
  return (
    <Container>
      {mediaList?.map((media) => (
        <MediaListImageItem key={media.id} media={media} onMediaSelected={onMediaSelected} />
      ))}
    </Container>
  );
};

const Container = styled(Box)`
  flex: 1 1 auto;
  flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-list/media-list-image.component.tsx